import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.restoreExpandedState()
  }

  toggleCourse(event) {
    const courseId = event.currentTarget.dataset.courseId
    const courseButton = event.currentTarget
    const modulesList = this.element.querySelector(`ul[data-course-id="${courseId}"]`)
    const toggleIcon = courseButton.querySelector('.toggle-icon')
    
    if (!modulesList) return

    const isExpanded = !modulesList.classList.contains('hidden')
    
    if (isExpanded) {
      // Сворачиваем курс
      modulesList.classList.add('hidden')
      toggleIcon.classList.remove('rotate-90')
      courseButton.classList.remove('expanded')
      this.saveCourseExpandedState(courseId, false)
    } else {
      // Разворачиваем курс
      modulesList.classList.remove('hidden')
      toggleIcon.classList.add('rotate-90')
      courseButton.classList.add('expanded')
      this.saveCourseExpandedState(courseId, true)
    }
  }

  toggleModule(event) {
    const moduleId = event.currentTarget.dataset.moduleId
    const moduleButton = event.currentTarget
    const lessonsList = this.element.querySelector(`ul[data-module-id="${moduleId}"]`)
    const toggleIcon = moduleButton.querySelector('.toggle-icon')
    
    if (!lessonsList) return

    const isExpanded = !lessonsList.classList.contains('hidden')
    
    if (isExpanded) {
      // Сворачиваем модуль
      lessonsList.classList.add('hidden')
      toggleIcon.classList.remove('rotate-90')
      moduleButton.classList.remove('expanded')
      this.saveExpandedState(moduleId, false)
    } else {
      // Разворачиваем модуль
      lessonsList.classList.remove('hidden')
      toggleIcon.classList.add('rotate-90')
      moduleButton.classList.add('expanded')
      this.saveExpandedState(moduleId, true)
    }
  }

  restoreExpandedState() {
    const expandedModules = this.getExpandedModules()
    const expandedCourses = this.getExpandedCourses()
    
    // Восстанавливаем состояние курсов
    this.element.querySelectorAll('.course-toggle').forEach(courseButton => {
      const courseId = courseButton.dataset.courseId
      const isExpanded = expandedCourses[courseId] !== false // по умолчанию развернут
      const modulesList = this.element.querySelector(`ul[data-course-id="${courseId}"]`)
      const toggleIcon = courseButton.querySelector('.toggle-icon')
      
      if (!modulesList) return

      if (isExpanded) {
        modulesList.classList.remove('hidden')
        toggleIcon.classList.add('rotate-90')
        courseButton.classList.add('expanded')
      } else {
        modulesList.classList.add('hidden')
        toggleIcon.classList.remove('rotate-90')
        courseButton.classList.remove('expanded')
      }
    })

    // Восстанавливаем состояние модулей
    this.element.querySelectorAll('.module-toggle').forEach(moduleButton => {
      const moduleId = moduleButton.dataset.moduleId
      const isExpanded = expandedModules[moduleId] !== false // по умолчанию развернут
      const lessonsList = this.element.querySelector(`ul[data-module-id="${moduleId}"]`)
      const toggleIcon = moduleButton.querySelector('.toggle-icon')
      
      if (!lessonsList) return

      if (isExpanded) {
        lessonsList.classList.remove('hidden')
        toggleIcon.classList.add('rotate-90')
        moduleButton.classList.add('expanded')
      } else {
        lessonsList.classList.add('hidden')
        toggleIcon.classList.remove('rotate-90')
        moduleButton.classList.remove('expanded')
      }
    })
  }

  saveCourseExpandedState(courseId, expanded) {
    const expandedCourses = this.getExpandedCourses()
    expandedCourses[courseId] = expanded
    this.setExpandedCourses(expandedCourses)
  }

  saveExpandedState(moduleId, expanded) {
    const expandedModules = this.getExpandedModules()
    expandedModules[moduleId] = expanded
    this.setExpandedModules(expandedModules)
  }

  getExpandedCourses() {
    try {
      const stored = localStorage.getItem('student_menu_expanded_courses')
      return stored ? JSON.parse(stored) : {}
    } catch (e) {
      console.warn('Ошибка при чтении localStorage для курсов:', e)
      return {}
    }
  }

  setExpandedCourses(courses) {
    try {
      localStorage.setItem('student_menu_expanded_courses', JSON.stringify(courses))
    } catch (e) {
      console.warn('Ошибка при записи в localStorage для курсов:', e)
    }
  }

  getExpandedModules() {
    try {
      const stored = localStorage.getItem('student_menu_expanded_modules')
      return stored ? JSON.parse(stored) : {}
    } catch (e) {
      console.warn('Ошибка при чтении localStorage:', e)
      return {}
    }
  }

  setExpandedModules(modules) {
    try {
      localStorage.setItem('student_menu_expanded_modules', JSON.stringify(modules))
    } catch (e) {
      console.warn('Ошибка при записи в localStorage:', e)
    }
  }
}
